import { render, staticRenderFns } from "./OutOrderComponent.vue?vue&type=template&id=00c872da&scoped=true&"
import script from "./OutOrderComponent.vue?vue&type=script&lang=js&"
export * from "./OutOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./OutOrderComponent.vue?vue&type=style&index=0&id=00c872da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c872da",
  null
  
)

export default component.exports